var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 23.6667H28.1C26.1398 23.6667 25.1597 23.6667 24.411 24.0481C23.7525 24.3837 23.217 24.9191 22.8815 25.5777C22.5 26.3264 22.5 27.3065 22.5 29.2667V37.9C22.5 39.8602 22.5 40.8403 22.8815 41.589C23.217 42.2475 23.7525 42.783 24.411 43.1185C25.1597 43.5 26.1398 43.5 28.1 43.5H36.7333C38.6935 43.5 39.6736 43.5 40.4223 43.1185C41.0809 42.783 41.6163 42.2475 41.9519 41.589C42.3333 40.8403 42.3333 39.8602 42.3333 37.9V34.1667M42.4749 23.5251C43.8417 24.892 43.8417 27.108 42.4749 28.4749C41.108 29.8417 38.892 29.8417 37.5251 28.4749C36.1583 27.108 36.1583 24.892 37.5251 23.5251C38.892 22.1583 41.108 22.1583 42.4749 23.5251Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.67b300d4dd7857020420d9de93c91bdb.svg";
export { ForwardRef as ReactComponent };